import React from 'react';

import { ClickAwayListener, IconButton } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cx from 'classnames';
import { TEACHERS_HOME_URL } from 'config/urls';
import { DATE_FORMATS } from 'constants/dateFormats';

import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/Home/assets/search-icon.svg';
import { formatDate } from 'utils/date';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';

import styles from './styles.module.scss';

const NavSearchAndFilter = ({
  userId,
  query,
  onChange,
  filtersOpen,
  setFiltersOpen,
  open,
  handleScroll,
  assignments,
  handleSelect,
  handleFiltersOpen,
  openSection,
  setOpenSection,
  sectionValue,
  setSectionValue,
  setPagination,
  userSections,
  classes,
  getRenderedSectionName
}) => {
  const handleSectionSelect = ({ level }) => {
    trackMixpanelEvent(userId, 'Select specific section.', {
      feature: 'Select section filtering',
      view: 'home page',
      normalizedURL: process.env.REACT_APP_BASE_FRONTEND_URL + TEACHERS_HOME_URL
    });

    setSectionValue(level.target.value);
    setFiltersOpen(false);
    setPagination({ offset: 0, limit: 20 });
  };

  return (
    <ClickAwayListener onClickAway={() => setFiltersOpen(false)}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchInput}>
          <IconButton className={styles.filterBtn} onClick={handleFiltersOpen}>
            <FilterIcon />
          </IconButton>

          <input
            type="text"
            placeholder="Search Assignments, Standards, or Sections here..."
            value={query}
            onChange={onChange}
          />

          <SearchIcon className={styles.searchIcon} />
        </div>

        {open && (
          <div className={styles.results} onScroll={handleScroll}>
            {assignments.length === 0 && (
              <div className={cx(styles.result, styles.empty)}>
                No assignments found
              </div>
            )}
            {assignments.map((assignment, index) => (
              <div
                key={index}
                className={styles.result}
                onClick={() => handleSelect({ assignment })}
              >
                <Tooltip title={assignment.name}>
                  <div className={styles.nameSection}>{assignment.name}</div>
                </Tooltip>
                <Tooltip title={assignment.section_name}>
                  <div className={styles.sectionBox}>
                    {assignment.section_name}
                  </div>
                </Tooltip>
                <div className={styles.dueDate}>
                  {formatDate({
                    date: assignment.due_date,
                    format: DATE_FORMATS.MEDIUM,
                    fallback: ''
                  })}
                </div>
              </div>
            ))}
          </div>
        )}

        {filtersOpen && (
          <div className={styles.filters}>
            <Select
              open={openSection}
              onClose={() => setOpenSection(false)}
              onOpen={() => setOpenSection(true)}
              value={sectionValue}
              onChange={(level) => {
                handleSectionSelect({ level: level });
              }}
              renderValue={(selected) =>
                getRenderedSectionName({
                  selected: selected,
                  userSections: userSections
                })
              }
              IconComponent={ExpandMoreIcon}
              className={classes.selectRoot}
              classes={{
                select: classes.inputText,
                icon: classes.selectIcon
              }}
              MenuProps={{ disablePortal: true }}
            >
              <MenuItem value="placeholder">Assignment Section</MenuItem>
              {userSections.map(({ id, name }) => (
                <MenuItem key={id} value={id} className={classes.menuItem}>
                  <Tooltip title={name}>
                    <span className={classes.menuItemText}>{name}</span>
                  </Tooltip>
                </MenuItem>
              ))}
            </Select>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default NavSearchAndFilter;
